import React from 'react';
import Table from './Templates/Table';
import SFCarousel from './Templates/SFCarousel';
import MultipleChoice from './MultipleChoice';
import MultipleSelect from './MultipleSelect';
import Simple from './Templates/Simple';
import List from './Templates/List';
import { FileUpload } from './FileUpload';
import { FileUploadContext } from '../../../Utils/Contexts';
import { returnSaneURL } from '../../../Utils/getImg';
import Button from '../Buttons/Button/Button';
import { T } from './Utils';
import RelatedOptions from './RelatedOptions/RelatedOptions';
import { FileUploadAPIType } from './Model';
import { TString } from '../Response/Utils';
import SingleCard from './Templates/SingleCard';
import WAMultiSelect from '../../ChannelComponents/Whatsapp/WAMultiSelect/index';
import { AddToCart } from '../Shopify/AddToCart/index';
import { ViewCart } from '../Shopify/ViewCart';
import ShowAllProducts from '../Shopify/ShowProducts';
import WAMultiChoice from '../../ChannelComponents/Whatsapp/WAMultiChoice';
import DisplayProduct from '../DisplayProduct';
interface Props {
	data: any | string;
	suggestions: any[];
	searchStatus: number;
	configData: any;
	handleSubmit: (msg: string, extraReqObj: any, config?) => void;
	shouldDisableActions: boolean;
	toggleLoginScreen: Function;
	triggerOauth: Function;
	promptLogin: boolean;
	showError: (val: FileUploadAPIType | null) => void;
	index: number;
	lengthArray: number;
	ResponseTypes: any;
	setResponseType: (type: string) => void;
	isInsideCampaign?: boolean;
	botImageCheck?: boolean;
	logoImagePath?: string;
	popUpSnackBar: Function;
	voiceResponse: boolean;
	langCode: string;
	flyFishChangesReq: boolean;
	taskName: string;
	addUserResponse: Function;
	timeStamp?: string;
	channel?: string;
	chatInput?: string;
	getProductDetails: Function;
	createCart: Function;
	addServerMessage: Function;
	getCartId: Function;
	makePayment: Function;
	handlePaymentStatus: Function;
	WorkflowData?: any;
	tenantId?: any;
	botId?: any;
	conversationId?: any;
	token?: any;
	colorMode?: string;
	selectedColor?: string;
	paymentStatus;
	productCarousel: boolean;
	colorScale?: string[];
	mainIndex?: number;
	maxIndex?: number;
	handleSelectedProduct?: any;
	reason: any;
	getProductDescription: Function;
	selectedTheme: string;
	selectedButton: any;
	recommendationHeading: string;
	showOnHover: string;
	userQuery;
	advisorTitle;
	enableStyleAdvisor;
	staticDetailsURL
}
const Bubble = (props: Props) => {
	let ToBeRendered: any = null;
	const {
		data,
		configData,
		handleSubmit,
		shouldDisableActions,
		showError,
		setResponseType,
		triggerOauth,
		promptLogin,
		toggleLoginScreen,
		index,
		lengthArray,
		ResponseTypes,
		isInsideCampaign,
		botImageCheck,
		productCarousel,
		logoImagePath,
		voiceResponse,
		langCode,
		flyFishChangesReq,
		timeStamp,
		channel,
		chatInput,
		addUserResponse,
		getProductDetails,
		createCart,
		getCartId,
		makePayment,
		addServerMessage,
		handlePaymentStatus,
		paymentStatus,
		WorkflowData,
		botId,
		tenantId,
		token,
		conversationId,
		colorMode,
		selectedColor,
		colorScale,
		mainIndex,
		maxIndex,
		handleSelectedProduct,
		reason,
		getProductDescription,
		selectedTheme,
		selectedButton,
		showOnHover,
		recommendationHeading,
		userQuery,
		advisorTitle,
		enableStyleAdvisor,
		staticDetailsURL
	} = props;

	let suggestionsList: any;
	let data1;

	const productPrice = (price: any) => {
		return Number(price)
			.toFixed(2)
			.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};

	const getFormatData = (response) => {
		let displayResponse = 'Here are your list';
		let newShopifyData;
		let shopifyData;
		let shopifyResponse = JSON.parse(response.displayResponse);
		let allShopifyProducts = [];
		// console.log(shopifyResponse)
		shopifyResponse.data.map((singleProduct: any, index: number) => {
			let singleItem: any;
			let compare_at_price = singleProduct.product.variants[0].compare_at_price
				? `₹${productPrice(singleProduct.product.variants[0].compare_at_price)}`
				: '';
			singleItem = {
				resourceURL: singleProduct.product.image.src,
				title: singleProduct.product.title,
				price: `<s className='caption-text'>${compare_at_price}</s> ₹${productPrice(
					singleProduct.product.variants[0].price
				)}`,
				description:
					'Made from breathable cotton, these shirts are great for casual home and active wear',
				cardIndex: index.toString(),
				productId: singleProduct.product.id,
			};
			allShopifyProducts.push(singleItem);
		});

		if (allShopifyProducts.length > 0) {
			newShopifyData = {
				displayResponse: displayResponse,
				responseType: 'CAROUSEL',
				listResponseType: 'MULTICHOICE',
				lists: { items: allShopifyProducts },
			};
		} else {
			newShopifyData = {
				displayResponse: '',
				responseType: 'SIMPLE',
			};
		}
		return newShopifyData;
	};

	if (data.responseType === ResponseTypes.SIMPLE && data.isMultiIntent) {
		data1 = data.displayResponse.split('<div')[0];
		var data2 = data.displayResponse.replace(data1, '');
		let regex = /<a (?:.*?)(?!\/a)*>(?:.*?)<\/a>/; //NOSONAR
		let data3 = data2.match(regex);
		var regExp = /\(([^)]+)\)/; //NOSONAR

		suggestionsList =
			data3 &&
			data3.map((e) => {
				return {
					actionText: e
						.match(/<a.+?\s*href\s*=\s*["]?([^">]*)["]?/)[1] //NOSONAR
						.match(regExp)[1]
						.replace(/'/g, ''),
					displayText: e.match(/>([^>]+)</)[1],
				};
			});
	}
	setResponseType(data.responseType);
	if (data.responseType.indexOf('FORM') > -1) {
		ToBeRendered = (
			<Simple
				userQuery={userQuery}
				data={data.displayResponse}
				metaData={data.lists || []}
				handleSubmit={handleSubmit}
				addUserResponse={addUserResponse}
				workflowData={WorkflowData}
				colorMode={colorMode}
				selectedColor={selectedColor}
				token={token}
				index={mainIndex}
				maxIndex={maxIndex}
				shouldDisableActions={shouldDisableActions}
				botId={botId}
				tenantId={tenantId}
				conversationId={conversationId}
				handleSelectedProduct={handleSelectedProduct}
				reason={reason}
				getProductDescription={getProductDescription}
				colorScale={colorScale}
				selectedTheme={selectedTheme}
				selectedButton={selectedButton}
				recommendationHeading={recommendationHeading}
				showOnHover={showOnHover}
				advisorTitle={advisorTitle}
				enableStyleAdvisor={enableStyleAdvisor}
				staticDetailsURL={staticDetailsURL}
			/>
		);
	} else if (data.responseType.indexOf('DETAILS') > -1) {
		ToBeRendered = (
			<Simple
				userQuery={userQuery}
				data={data.displayResponse}
				metaData={data.lists || []}
				handleSubmit={handleSubmit}
				addUserResponse={addUserResponse}
				workflowData={WorkflowData}
				colorMode={colorMode}
				selectedColor={selectedColor}
				token={token}
				index={mainIndex}
				maxIndex={maxIndex}
				shouldDisableActions={shouldDisableActions}
				botId={botId}
				tenantId={tenantId}
				conversationId={conversationId}
				handleSelectedProduct={handleSelectedProduct}
				details={true}
				productData={data}
				getProductDescription={getProductDescription}
				reason={reason}
				colorScale={colorScale}
				selectedTheme={selectedTheme}
				selectedButton={selectedButton}
				recommendationHeading={recommendationHeading}
				showOnHover={showOnHover}
				advisorTitle={advisorTitle}
				enableStyleAdvisor={enableStyleAdvisor}
				staticDetailsURL={staticDetailsURL}
			/>
		);
	} else if (
		data.displayResponse &&
		data.displayResponse.indexOf('"serviceType":"shopify"') > -1
	) {
		if (data.displayResponse.indexOf('"apiType":"product_search"') > -1) {
			if (
				data.displayResponse.indexOf('"status":"Failed"') > -1 ||
				data.displayResponse.indexOf('"data":[]') > -1
			) {
				let response = 'Searched product is not available';
				//  JSON.parse(data.displayResponse)
				// response.message
				ToBeRendered = (
					<Simple data={response} metaData={data.metaData || []} />
				);
			} else {
				ToBeRendered = (
					<ShowAllProducts
						data={getFormatData(data)}
						shouldDisableActions={shouldDisableActions}
						handleSubmit={handleSubmit}
						isMultiChoice={true}
						isInsideCampaign={isInsideCampaign}
						index={index}
						lengthArray={lengthArray}
						botImageCheck={botImageCheck}
						logoImagePath={props.logoImagePath}
						voiceResponse={voiceResponse}
						langCode={langCode}
						flyFishChangesReq={flyFishChangesReq}
						addUserResponse={addUserResponse}
					/>
				);
			}
		} else if (
			data.displayResponse.indexOf('"apiType":"product_detail"') > -1
		) {
			if (data.displayResponse.indexOf('"status":"Failed"') > -1) {
				let response = JSON.parse(data.displayResponse);
				ToBeRendered = (
					<Simple data={response.data} metaData={data.metaData || []} />
				);
			} else {
				ToBeRendered = (
					<AddToCart
						data={data}
						handleSubmit={handleSubmit}
						shouldDisableActions={shouldDisableActions}
						isMultiSelect={true}
						isInsideCampaign={isInsideCampaign}
						index={index}
						lengthArray={lengthArray}
						botImageCheck={botImageCheck}
						logoImagePath={props.logoImagePath}
						langCode={langCode}
						flyFishChangesReq={flyFishChangesReq}
						addUserResponse={addUserResponse}
						createCart={createCart}
						configData={configData}
					/>
				);
			}
		} else {
			if (data.displayResponse.indexOf('"status":"Failed"') > -1) {
				let response = JSON.parse(data.displayResponse);
				ToBeRendered = (
					<Simple data={response.message} metaData={data.metaData || []} />
				);
			} else {
				ToBeRendered = (
					<ViewCart
						data={data}
						handleSubmit={handleSubmit}
						isInsideCampaign={isInsideCampaign}
						botImageCheck={botImageCheck}
						index={index}
						logoImagePath={logoImagePath}
						voiceResponse={voiceResponse}
						langCode={langCode}
						lengthArray={lengthArray}
						shouldDisableActions={shouldDisableActions}
						addUserResponse={addUserResponse}
						addServerMessage={addServerMessage}
						getCartId={getCartId}
						makePayment={makePayment}
					/>
				);
			}
		}
	} else if (data.listResponseType === ResponseTypes.MULTICHOICE) {
		if (!data.isRichElement && channel !== 'whatsapp') {
			if (data.type == 'QUICKLINKS') {
				ToBeRendered = (
					<MultipleChoice
						data={data}
						handleSubmit={handleSubmit}
						shouldDisableActions={shouldDisableActions}
						index={index}
						botImageCheck={botImageCheck}
						logoImagePath={logoImagePath}
						voiceResponse={voiceResponse}
						channel={channel}
						timeStamp={timeStamp}
						configData={configData}
					/>
				);
			} else
				ToBeRendered = (
					<DisplayProduct
						metadata={data.lists.items}
						getProductDetails={getProductDetails}
						message={data.displayResponse}
						shouldDisableActions={shouldDisableActions}
					/>
					// <MultipleChoice
					// 	data={data}
					// 	handleSubmit={handleSubmit}
					// 	shouldDisableActions={shouldDisableActions}
					// 	index={index}
					// 	botImageCheck={botImageCheck}
					// 	logoImagePath={logoImagePath}
					// 	voiceResponse={voiceResponse}
					// 	channel={channel}
					// 	timeStamp={timeStamp}
					// />
				);
		} else if (data.responseType === ResponseTypes.LIST) {
			ToBeRendered = (
				<List
					data={data}
					handleSubmit={handleSubmit}
					shouldDisableActions={shouldDisableActions}
					isMultiChoice={true}
					index={index}
					lengthArray={lengthArray}
					botImageCheck={botImageCheck}
					logoImagePath={props.logoImagePath}
					voiceResponse={voiceResponse}
					langCode={langCode}
					addUserResponse={addUserResponse}
					channel={channel}
					timeStamp={timeStamp}
				/>
			);
		} else
			ToBeRendered =
				data.lists && data.lists.items.length > 1 ? (
					channel === 'whatsapp' ? (
						<WAMultiChoice
							data={data}
							handleSubmit={handleSubmit}
							shouldDisableActions={shouldDisableActions}
							index={index}
							botImageCheck={botImageCheck}
							logoImagePath={logoImagePath}
							voiceResponse={voiceResponse}
							timeStamp={timeStamp}
							channel={channel}
						/>
					) : (
						<Simple
							userQuery={userQuery}
							data={data.displayResponse || data.actualResponse || ''}
							isRatingTask={data.isRatingTask}
							ratingTypeId={data.ratingTypeId}
							handleSubmit={handleSubmit}
							shouldDisableActions={shouldDisableActions}
							popUpSnackBar={props.popUpSnackBar}
							langCode={langCode}
							flyFishChangesReq={flyFishChangesReq}
							timeStamp={timeStamp}
							channel={props.channel}
							metaData={data.metaData || []}
							handlePaymentStatus={handlePaymentStatus}
							paymentStatus={paymentStatus}
							colorMode={colorMode}
							selectedColor={selectedColor}
							colorScale={colorScale}
							showProduct={
								data.responseType == 'CAROUSEL' &&
									data.type &&
									data.type == 'nonproduct'
									? 'DescCard'
									: true
							}
							tenantId={tenantId}
							productData={data}
							createCart={createCart}
							token={token}
							index={mainIndex}
							maxIndex={maxIndex}
							handleSelectedProduct={handleSelectedProduct}
							reason={reason}
							getProductDescription={getProductDescription}
							selectedTheme={selectedTheme}
							selectedButton={selectedButton}
							recommendationHeading={recommendationHeading}
							showOnHover={showOnHover}
							conversationId={conversationId}
							advisorTitle={advisorTitle}
							enableStyleAdvisor={enableStyleAdvisor}
							staticDetailsURL={staticDetailsURL}
						/>
						// <SFCarousel
						// 	data={data}
						// 	shouldDisableActions={shouldDisableActions}
						// 	handleSubmit={handleSubmit}
						// 	isMultiChoice={true}
						// 	isInsideCampaign={isInsideCampaign}
						// 	index={index}
						// 	lengthArray={lengthArray}
						// 	botImageCheck={botImageCheck}
						// 	logoImagePath={props.logoImagePath}
						// 	voiceResponse={voiceResponse}
						// 	langCode={langCode}
						// 	flyFishChangesReq={flyFishChangesReq}
						// 	addUserResponse={addUserResponse}
						// 	getProductDetails={getProductDetails}
						// />
					)
				) : data.lists && data.lists.items.length > 1 ? (
					(ToBeRendered = (
						<Simple
							userQuery={userQuery}
							data={data.displayResponse || data.actualResponse || ''}
							isRatingTask={data.isRatingTask}
							ratingTypeId={data.ratingTypeId}
							handleSubmit={handleSubmit}
							shouldDisableActions={shouldDisableActions}
							popUpSnackBar={props.popUpSnackBar}
							langCode={langCode}
							flyFishChangesReq={flyFishChangesReq}
							timeStamp={timeStamp}
							channel={props.channel}
							metaData={data.metaData || []}
							handlePaymentStatus={handlePaymentStatus}
							paymentStatus={paymentStatus}
							colorMode={colorMode}
							selectedColor={selectedColor}
							colorScale={colorScale}
							showProduct={
								data.responseType == 'CAROUSEL' &&
									data.type &&
									data.type == 'nonproduct'
									? 'DescCard'
									: true
							}
							tenantId={tenantId}
							handleSelectedProduct={handleSelectedProduct}
							productData={data}
							createCart={createCart}
							index={mainIndex}
							maxIndex={maxIndex}
							reason={reason}
							token={token}
							getProductDescription={getProductDescription}
							selectedTheme={selectedTheme}
							selectedButton={selectedButton}
							recommendationHeading={recommendationHeading}
							showOnHover={showOnHover}
							conversationId={conversationId}
							advisorTitle={advisorTitle}
							enableStyleAdvisor={enableStyleAdvisor}
							staticDetailsURL={staticDetailsURL}
						/>
					))
				) : data.lists && data.lists.items.length > 1 ? (
					(ToBeRendered = (
						<Simple
							userQuery={userQuery}
							data={data.displayResponse || data.actualResponse || ''}
							isRatingTask={data.isRatingTask}
							ratingTypeId={data.ratingTypeId}
							handleSubmit={handleSubmit}
							shouldDisableActions={shouldDisableActions}
							popUpSnackBar={props.popUpSnackBar}
							langCode={langCode}
							flyFishChangesReq={flyFishChangesReq}
							timeStamp={timeStamp}
							channel={props.channel}
							metaData={data.metaData || []}
							handlePaymentStatus={handlePaymentStatus}
							paymentStatus={paymentStatus}
							colorMode={colorMode}
							selectedColor={selectedColor}
							colorScale={colorScale}
							showProduct={
								data.responseType == 'CAROUSEL' &&
									data.type &&
									data.type == 'nonproduct'
									? 'DescCard'
									: true
							}
							tenantId={tenantId}
							handleSelectedProduct={handleSelectedProduct}
							productData={data}
							createCart={createCart}
							index={mainIndex}
							token={token}
							maxIndex={maxIndex}
							reason={reason}
							getProductDescription={getProductDescription}
							selectedTheme={selectedTheme}
							selectedButton={selectedButton}
							recommendationHeading={recommendationHeading}
							showOnHover={showOnHover}
							conversationId={conversationId}
							advisorTitle={advisorTitle}
							staticDetailsURL={staticDetailsURL}
							enableStyleAdvisor={enableStyleAdvisor}
						/>
					))
				) : data.lists && data.lists.items.length > 0 ? (
					<Simple
						userQuery={userQuery}
						data={data.displayResponse || data.actualResponse || ''}
						isRatingTask={data.isRatingTask}
						ratingTypeId={data.ratingTypeId}
						handleSubmit={handleSubmit}
						shouldDisableActions={shouldDisableActions}
						popUpSnackBar={props.popUpSnackBar}
						langCode={langCode}
						flyFishChangesReq={flyFishChangesReq}
						timeStamp={timeStamp}
						channel={props.channel}
						metaData={data.metaData || []}
						handlePaymentStatus={handlePaymentStatus}
						paymentStatus={paymentStatus}
						colorMode={colorMode}
						selectedColor={selectedColor}
						colorScale={colorScale}
						showProduct={
							data.responseType == 'CAROUSEL' &&
								data.type &&
								data.type == 'nonproduct'
								? 'DescCard'
								: true
						}
						tenantId={tenantId}
						handleSelectedProduct={handleSelectedProduct}
						productData={data}
						createCart={createCart}
						index={mainIndex}
						token={token}
						maxIndex={maxIndex}
						reason={reason}
						getProductDescription={getProductDescription}
						selectedTheme={selectedTheme}
						selectedButton={selectedButton}
						recommendationHeading={recommendationHeading}
						showOnHover={showOnHover}
						conversationId={conversationId}
						advisorTitle={advisorTitle}
						enableStyleAdvisor={enableStyleAdvisor}
						staticDetailsURL={staticDetailsURL}
					/>
				) : (
					<List
						data={data}
						handleSubmit={handleSubmit}
						shouldDisableActions={shouldDisableActions}
						isMultiChoice={true}
						index={index}
						lengthArray={lengthArray}
						botImageCheck={botImageCheck}
						logoImagePath={props.logoImagePath}
						voiceResponse={voiceResponse}
						langCode={langCode}
						addUserResponse={addUserResponse}
						channel={channel}
						timeStamp={timeStamp}
						getProductDetails={getProductDetails}
					/>
				);
	} else if (data.listResponseType === ResponseTypes.MULTISELECT) {
		if (!data.isRichElement)
			ToBeRendered =
				channel === 'whatsapp' ? (
					<WAMultiSelect
						data={data}
						handleSubmit={handleSubmit}
						shouldDisableActions={shouldDisableActions}
						isMultiSelect={true}
						isInsideCampaign={isInsideCampaign}
						index={index}
						lengthArray={lengthArray}
						botImageCheck={botImageCheck}
						logoImagePath={props.logoImagePath}
						langCode={langCode}
						timeStamp={timeStamp}
						chatInput={chatInput}
						type='list'
						addUserResponse={addUserResponse}
					/>
				) : (
					<MultipleSelect
						data={data}
						handleSubmit={handleSubmit}
						primaryColor={configData.primaryColor}
						shouldDisableActions={shouldDisableActions}
						voiceResponse={voiceResponse}
						langCode={langCode}
					/>
				);
		else if (data.responseType === ResponseTypes.LIST)
			ToBeRendered = (
				<List
					data={data}
					handleSubmit={handleSubmit}
					shouldDisableActions={shouldDisableActions}
					isMultiSelect={true}
					index={index}
					lengthArray={lengthArray}
					botImageCheck={botImageCheck}
					logoImagePath={props.logoImagePath}
					voiceResponse={voiceResponse}
					langCode={langCode}
					addUserResponse={addUserResponse}
					channel={channel}
					timeStamp={timeStamp}
					getProductDetails={getProductDetails}
				/>
			);
		else
			ToBeRendered =
				data.lists && data.lists.items.length > 1 ? (
					channel === 'whatsapp' ? (
						<WAMultiSelect
							data={data}
							handleSubmit={handleSubmit}
							shouldDisableActions={shouldDisableActions}
							isMultiSelect={true}
							isInsideCampaign={isInsideCampaign}
							index={index}
							lengthArray={lengthArray}
							botImageCheck={botImageCheck}
							logoImagePath={props.logoImagePath}
							langCode={langCode}
							timeStamp={timeStamp}
							chatInput={chatInput}
							type='card'
							addUserResponse={addUserResponse}
						/>
					) : (
						<SFCarousel
							data={data}
							handleSubmit={handleSubmit}
							shouldDisableActions={shouldDisableActions}
							isMultiSelect={true}
							isInsideCampaign={isInsideCampaign}
							index={index}
							lengthArray={lengthArray}
							botImageCheck={botImageCheck}
							logoImagePath={props.logoImagePath}
							langCode={langCode}
							flyFishChangesReq={flyFishChangesReq}
							getProductDetails={getProductDetails}
							tenantId={tenantId}
							token={token}
						/>
					)
				) : channel === 'whatsapp' ? (
					//for rendering single card
					<WAMultiSelect
						data={data}
						handleSubmit={handleSubmit}
						shouldDisableActions={shouldDisableActions}
						isMultiSelect={true}
						isInsideCampaign={isInsideCampaign}
						index={index}
						lengthArray={lengthArray}
						botImageCheck={botImageCheck}
						logoImagePath={props.logoImagePath}
						langCode={langCode}
						timeStamp={timeStamp}
						chatInput={chatInput}
						type='card'
						addUserResponse={addUserResponse}
					/>
				) : (
					<List
						data={data}
						handleSubmit={handleSubmit}
						shouldDisableActions={shouldDisableActions}
						isMultiSelect={true}
						index={index}
						lengthArray={lengthArray}
						botImageCheck={botImageCheck}
						logoImagePath={props.logoImagePath}
						voiceResponse={voiceResponse}
						langCode={langCode}
						addUserResponse={addUserResponse}
						channel={channel}
						timeStamp={timeStamp}
						getProductDetails={getProductDetails}
					/>
				);
	} else if (data.responseType === ResponseTypes.SIMPLE) {
		// if(data.displayResponse.indexOf('<a href=') > -1)
		// {
		// 	let response = data.displayResponse.split('"')
		// 	ToBeRendered = (
		// 		<Simple
		// 			data={data.displayResponse || data.actualResponse || ''}
		// 			isRatingTask={data.isRatingTask}
		// 			ratingTypeId={data.ratingTypeId}
		// 			handleSubmit={handleSubmit}
		// 			shouldDisableActions={shouldDisableActions}
		// 			popUpSnackBar={props.popUpSnackBar}
		// 			langCode={langCode}
		// 		/>
		// 	)
		// 	window.open(response[1])
		// 	return
		// }
		// else{
		ToBeRendered =
			data.fileUploadDetails && data.fileUploadDetails.typeId ? (
				<FileUploadContext.Provider
					value={{
						...data.fileUploadDetails,
						fileUploadAPI: configData.fileUploadAPI,
					}}
				>
					<FileUpload
						handleSubmit={handleSubmit}
						shouldDisableActions={shouldDisableActions}
						showError={showError}
						displayResponse={data.displayResponse || data.actualResponse || ''}
					/>
				</FileUploadContext.Provider>
			) : data.isMultiIntent ? (
				<RelatedOptions
					data={data1}
					multiIntent={data.isMultiIntent}
					suggestions={suggestionsList}
					handleSubmit={handleSubmit}
					voiceResponse={voiceResponse}
				/>
			) : (
				<Simple
					userQuery={userQuery}
					data={data.displayResponse || data.actualResponse || ''}
					isRatingTask={data.isRatingTask}
					ratingTypeId={data.ratingTypeId}
					handleSubmit={handleSubmit}
					shouldDisableActions={shouldDisableActions}
					popUpSnackBar={props.popUpSnackBar}
					langCode={langCode}
					flyFishChangesReq={flyFishChangesReq}
					timeStamp={timeStamp}
					channel={props.channel}
					metaData={data.metaData || []}
					handlePaymentStatus={handlePaymentStatus}
					paymentStatus={paymentStatus}
					colorMode={colorMode}
					selectedColor={selectedColor}
					colorScale={colorScale}
					index={mainIndex}
					maxIndex={maxIndex}
					tenantId={tenantId}
					token={token}
					productData={data}
					handleSelectedProduct={handleSelectedProduct}
					reason={reason}
					getProductDescription={getProductDescription}
					selectedTheme={selectedTheme}
					selectedButton={selectedButton}
					recommendationHeading={recommendationHeading}
					showOnHover={showOnHover}
					conversationId={conversationId}
					advisorTitle={advisorTitle}
					enableStyleAdvisor={enableStyleAdvisor}
					staticDetailsURL={staticDetailsURL}
				/>
			);
		// }
	} else if (data.responseType === ResponseTypes.LIST)
		ToBeRendered = (
			<List
				data={data}
				index={index}
				singleCard={data.responseType === ResponseTypes.CARD ? true : false}
				lengthArray={lengthArray}
				botImageCheck={botImageCheck}
				logoImagePath={props.logoImagePath}
				voiceResponse={voiceResponse}
				langCode={langCode}
				addUserResponse={addUserResponse}
				channel={channel}
				timeStamp={timeStamp}
				getProductDetails={getProductDetails}
			/>
		);
	else if (data.responseType === ResponseTypes.CARD)
		ToBeRendered = (
			<SingleCard
				data={data}
				index={index}
				botImageCheck={botImageCheck}
				logoImagePath={props.logoImagePath}
			/>
		);
	else if (data.responseType === ResponseTypes.CAROUSEL)
		ToBeRendered =
			data.lists && data.lists.items.length > 1 ? (
				channel === 'whatsapp' ? (
					<WAMultiSelect
						data={data}
						handleSubmit={handleSubmit}
						shouldDisableActions={shouldDisableActions}
						isMultiSelect={true}
						isInsideCampaign={isInsideCampaign}
						index={index}
						lengthArray={lengthArray}
						botImageCheck={botImageCheck}
						logoImagePath={props.logoImagePath}
						langCode={langCode}
						timeStamp={timeStamp}
						chatInput={chatInput}
						type='card'
						addUserResponse={addUserResponse}
					/>
				) : (
					<SFCarousel
						data={data}
						isInsideCampaign={isInsideCampaign}
						index={index}
						lengthArray={lengthArray}
						botImageCheck={botImageCheck}
						logoImagePath={props.logoImagePath}
						voiceResponse={voiceResponse}
						langCode={langCode}
						flyFishChangesReq={flyFishChangesReq}
						getProductDetails={getProductDetails}
						tenantId={tenantId}
						token={token}
					/>
				)
			) : (
				<List
					data={data}
					index={index}
					singleCard={data.responseType === ResponseTypes.CARD ? true : false}
					lengthArray={lengthArray}
					botImageCheck={botImageCheck}
					logoImagePath={props.logoImagePath}
					voiceResponse={voiceResponse}
					langCode={langCode}
					addUserResponse={addUserResponse}
					channel={channel}
					timeStamp={timeStamp}
					getProductDetails={getProductDetails}
				/>
			);
	else if (data.responseType === ResponseTypes.TABLE)
		ToBeRendered = (
			<Table
				data={data}
				primaryColor={configData.primaryColor}
				shouldDisableActions={shouldDisableActions}
				voiceResponse={voiceResponse}
				channel={channel}
				timeStamp={timeStamp}
				langCode={langCode}
				handleSubmit={handleSubmit}
			/>
		);
	else if (data.responseType === ResponseTypes.FILEUPLOAD) {
		ToBeRendered = (
			<FileUploadContext.Provider
				value={{
					...data.fileUploadDetails,
					fileUploadAPI: configData.fileUploadAPI,
				}}
			>
				<FileUpload
					handleSubmit={handleSubmit}
					shouldDisableActions={shouldDisableActions}
					showError={showError}
					displayResponse={data.displayResponse || data.actualResponse || ''}
				/>
			</FileUploadContext.Provider>
		);
	}

	return (
		<>
			{!data.isRichElement &&
				(data.listResponseType || data.responseType === ResponseTypes.TABLE) ? (
				botImageCheck && index == 0 ? (
					<div className={'preview-image-holder'}>
						<img
							src={returnSaneURL(logoImagePath)}
							alt={TString({ labelName: 'botAvatarLabel' })}
						/>
					</div>
				) : null
			) : null}
			{ToBeRendered}
			{promptLogin ? (
				<Button
					onClick={() => toggleLoginScreen(triggerOauth)}
					variant={'filled'}
					disabled={shouldDisableActions}
					fullWidth
					label={<T labelName='loginLabel' />}
					style={{ margin: '16px 0 0' }}
				/>
			) : (
				''
			)}
		</>
	);
};
export default Bubble;
